import React, { useCallback, useEffect, useState } from 'react';
import * as api from '../../billMemory/api';
import { checkRowText, lastSavesText } from '../../billMemory/client';
import RevertLineButton from './RevertLineButton';

/**
 * Invexis admin — the weekly audit (Fix plan, Fix 3B and I3): the half of each business's sample routed to
 * Invexis, rows a silent business left for 3 days, and rows a business marked Wrong (flagged). An Invexis mark is
 * final: Right, Wrong (its lesson asks again), or Wrong and forget the lesson; a Wrong offers "Revert this line".
 */
export default function AuditView() {
  const [rows, setRows] = useState(null);
  const [done, setDone] = useState({});
  const load = useCallback(() => Promise.resolve(api.getAudit()).then((r) => setRows((r && r.rows) || [])).catch(() => setRows([])), []);
  useEffect(() => { load(); }, [load]);
  const mark = async (r, verdict, forget = false) => {
    try {
      const out = await api.markAudit(r.sample_id, verdict, forget);
      setDone((d) => ({ ...d, [r.sample_id]: { verdict, revert: out && out.revert } }));
    } catch (e) {
      setDone((d) => ({ ...d, [r.sample_id]: { error: (e && e.message) || 'That was refused.' } }));
    }
  };
  return (
    <section className="bm-panel">
      <h3>Audit</h3>
      {!rows && <div className="bm-note">Loading…</div>}
      {rows && !rows.length && <div className="bm-note">Nothing to review.</div>}
      <ul className="bm-log">
        {(rows || []).map((r) => {
          const d = done[r.sample_id];
          return (
            <li key={r.sample_id}>
              <div>{`${r.business_name}: ${checkRowText(r)}`}</div>
              {r.flagged && <div className="bm-note">Flagged by the business</div>}
              {lastSavesText(r) && <div className="bm-note">{lastSavesText(r)}</div>}
              {!d || d.error ? (
                <span>
                  <button type="button" className="irr-secondary-btn" onClick={() => mark(r, 'right')}>Right</button>{' '}
                  <button type="button" className="irr-secondary-btn" onClick={() => mark(r, 'wrong')}>Wrong</button>{' '}
                  <button type="button" className="irr-secondary-btn" onClick={() => mark(r, 'wrong', true)}>Wrong, forget it</button>
                  {d && d.error && <span className="bm-note">{` ${d.error}`}</span>}
                </span>
              ) : (
                <span>
                  <span className="bm-note">{d.verdict === 'right' ? 'Marked right. ' : 'Marked wrong. '}</span>
                  {d.verdict === 'wrong' && <RevertLineButton revert={d.revert} />}
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
